class CartDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.get("cart") === "open") {
      this.show();
    }

    this.events();
  }

  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));
    this.updateCartParam(true);

    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
    this.updateCartParam(false);
  }

  changeSubscription(item, element) {
    this.change({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    });
  }

  changeIntoSubscription(item) {
    const data = {
      "items": [item]
    };
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then(() => {
      this.change({ id: item.key, quantity: 0 });
    });
  }

  change(data, element) {
    const container = element ? element.closest(".spinner-container") : null;

    if (container) {
      container.classList.add("state--loading");
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: data
      }));

      const giftLinesToRemove = this.checkCartGifts(data);

      if (giftLinesToRemove.length) {
        return this.removeCartGifts(giftLinesToRemove)
          .then(() => this.render());
      }

      return this.render();
    })
    .catch((error) => {
      if (container) {
        container.classList.remove("state--loading");
      }

      console.error("CartDrawer: change failed", error);
    });
  }

  updateCartParam(isOpen) {
    const url = new URL(window.location.href);

    if (isOpen) {
      url.searchParams.set("cart", "open");
    } else {
      url.searchParams.delete("cart");
    }

    window.history.replaceState({}, "", url);
  }

  render() {
    const current_content = document.getElementById("cart");

    function get_new_content(response) {
      const string = JSON.parse(response)["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(string, "text/html");

      return doc.getElementById("cart");
    }

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        current_content.replaceWith(get_new_content(response));
      })
      .then(() => this.events())
      .then(() => this.logCartGifts())
      .then(() => this.initLoop());
  }

  logCartGifts() {
    const el = this.querySelector('[data-cart-gifts]');

    if (!el) {
      console.log('cart gifts: no element');
      return;
    }

    const threshold = el.dataset.threshold;
    const giftProductIds = el.dataset.giftProductIds;

    console.log('cart gifts threshold:', threshold);
    console.log('cart gifts product ids:', giftProductIds);
  }

  checkCartGifts(cart) {
    const el = this.querySelector('[data-cart-gifts]');

    if (!el) {
      console.log('checkCartGifts: no element');
      return [];
    }

    const threshold = parseInt(el.dataset.threshold, 10);

    console.log('checkCartGifts threshold:', threshold);

    let giftTotal = 0;
    const giftLinesToRemove = [];

    cart.items.forEach((item) => {
      if (item.properties && item.properties._cart_gift === 'true') {
        giftTotal += item.line_price;
        giftLinesToRemove.push({
          id: item.key,
          quantity: 0
        });
      }
    });

    const qualifyingTotal = cart.items_subtotal_price - giftTotal;

    console.log('checkCartGifts subtotal:', cart.items_subtotal_price);
    console.log('checkCartGifts giftTotal:', giftTotal);
    console.log('checkCartGifts qualifyingTotal:', qualifyingTotal);

    if (qualifyingTotal < threshold) {
      console.log('checkCartGifts: below threshold, should remove gift');
      console.log('checkCartGifts lines to remove:', giftLinesToRemove);
      return giftLinesToRemove;
    }

    console.log('checkCartGifts: still qualifies');
    return [];
  }

  removeCartGifts(lines) {
    const requests = lines.map((line) => {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(line)
      }).then((response) => response.json());
    });

    return Promise.all(requests).then((responses) => {
      console.log('removeCartGifts responses:', responses);
      return responses;
    });
  }

  initLoop() {
    if (window.LoopOnstore && window.LoopOnstore.isActive()) {
      const routeCheckoutButton = document.querySelector('a[name="button-route-3"]');
      if (routeCheckoutButton) {
        routeCheckoutButton.style.setProperty('display', 'none', 'important');
      }
      const shopifyCheckoutButton = document.querySelector('#checkout-button');
      if (shopifyCheckoutButton) {
        shopifyCheckoutButton.style.removeProperty('display');
      }
    }
  }
}

customElements.define("cart-drawer", CartDrawer);
